// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro-container {
  display: flex;
  flex-direction: column;
}
.intro-container .intro-header {
  padding-left: 20px;
}
.intro-container .misc-actions-container .intro-cta-btns {
  display: flex;
  flex-direction: row;
}
.intro-container .intro-description {
  display: flex;
  margin-bottom: 20px;
}
.intro-container .intro-banner-container {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  height: 340px;
}
.intro-container .intro-banner-container img {
  width: 100%;
}
.intro-container .carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}
.intro-container .carousel-fade .carousel-item.active,
.intro-container .carousel-fade .carousel-item-next.carousel-item-left,
.intro-container .carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1;
}
.intro-container .carousel-fade .active.carousel-item-left,
.intro-container .carousel-fade .active.carousel-item-right {
  opacity: 0;
}
.intro-container .carousel-fade .carousel-item-next,
.intro-container .carousel-fade .carousel-item-prev,
.intro-container .carousel-fade .carousel-item.active,
.intro-container .carousel-fade .active.carousel-item-left,
.intro-container .carousel-fade .active.carousel-item-prev {
  transform: translateX(0);
  transform: translate3d(0, 0, 0);
}
.intro-container .intro-page-content {
  display: flex;
  padding: 30px;
  flex-direction: column;
}

.intro {
  display: flex;
  padding-top: 25px;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 0 20% 0 20%;
  font-size: 16px;
  margin-bottom: 50px;
}

.carousel-control-next, .carousel-control-prev {
  width: 8% !important;
}

.carousel-indicators [data-bs-target] {
  width: 10px !important;
  height: 10px !important;
  border-radius: 100%;
}

.icon-sort {
  font-size: 14px;
  margin-left: -4px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/intro.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;AACD;AAAC;EACC,kBAAA;AAEF;AAAC;EACC,aAAA;EACA,mBAAA;AAEF;AAAC;EACC,aAAA;EACA,mBAAA;AAEF;AAAC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAEF;AADE;EACC,WAAA;AAGH;AAAC;EACC,UAAA;EACA,yBAAA;EACA,4BAAA;AAEF;AACC;;;EAGC,UAAA;AACF;AAEC;;EAEC,UAAA;AAAF;AAGC;;;;;EAKC,wBAAA;EACA,+BAAA;AADF;AAGC;EACC,aAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AADD;;AAIA;EACC,oBAAA;AADD;;AAGA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACC,eAAA;EACA,iBAAA;AAAD","sourcesContent":[".intro-container {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\t.intro-header {\r\n\t\tpadding-left: 20px;\r\n\t}\r\n\t.misc-actions-container .intro-cta-btns {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\t}\r\n\t.intro-description {\r\n\t\tdisplay: flex;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.intro-banner-container {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tmargin-top: 25px;\r\n\t\theight: 340px;\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n\t.carousel-fade .carousel-item {\r\n\t\topacity: 0;\r\n\t\ttransition-duration: .6s;\r\n\t\ttransition-property: opacity;\r\n\t}\r\n\r\n\t.carousel-fade  .carousel-item.active,\r\n\t.carousel-fade  .carousel-item-next.carousel-item-left,\r\n\t.carousel-fade  .carousel-item-prev.carousel-item-right {\r\n\t\topacity: 1;\r\n\t}\r\n\r\n\t.carousel-fade .active.carousel-item-left,\r\n\t.carousel-fade  .active.carousel-item-right {\r\n\t\topacity: 0;\r\n\t}\r\n\r\n\t.carousel-fade  .carousel-item-next,\r\n\t.carousel-fade .carousel-item-prev,\r\n\t.carousel-fade .carousel-item.active,\r\n\t.carousel-fade .active.carousel-item-left,\r\n\t.carousel-fade  .active.carousel-item-prev {\r\n\t\ttransform: translateX(0);\r\n\t\ttransform: translate3d(0, 0, 0);\r\n\t}\r\n\t.intro-page-content {\r\n\t\tdisplay: flex;\r\n\t\tpadding: 30px;\r\n\t\tflex-direction: column;\r\n\t}\r\n}\r\n.intro {\r\n\tdisplay: flex;\r\n\tpadding-top: 25px;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-align: center;\r\n\tflex-direction: column;\r\n\tpadding: 0 20% 0 20%;\r\n\tfont-size: 16px;\r\n\tmargin-bottom: 50px;\r\n}\r\n\r\n.carousel-control-next, .carousel-control-prev {\r\n\twidth: 8% !important;\r\n}\r\n.carousel-indicators [data-bs-target] {\r\n  width: 10px !important;\r\n  height: 10px !important;\r\n  border-radius: 100%;\r\n}\r\n\r\n.icon-sort {\r\n\tfont-size: 14px;\r\n\tmargin-left: -4px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
